export default __webpack_public_path__ + "static/media/SFC-Logo-bw.7a9c5b29.png";